function hexToHsl(hex: string): [number, number, number] {
  const r = parseInt(hex.slice(1, 3), 16) / 255;
  const g = parseInt(hex.slice(3, 5), 16) / 255;
  const b = parseInt(hex.slice(5, 7), 16) / 255;

  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  let h = 0;
  let s = 0;
  const l = (max + min) / 2;

  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r: h = ((g - b) / d + (g < b ? 6 : 0)) / 6; break;
      case g: h = ((b - r) / d + 2) / 6; break;
      case b: h = ((r - g) / d + 4) / 6; break;
    }
  }

  return [Math.round(h * 360), Math.round(s * 100), Math.round(l * 100)];
}

function hslToHex(h: number, s: number, l: number): string {
  s /= 100;
  l /= 100;
  const a = s * Math.min(l, 1 - l);
  const f = (n: number) => {
    const k = (n + h / 30) % 12;
    const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return Math.round(255 * color).toString(16).padStart(2, '0');
  };
  return `#${f(0)}${f(8)}${f(4)}`;
}

const SHADE_LIGHTNESS: Record<string, number> = {
  '50': 97, '100': 93, '200': 86, '300': 76, '400': 62,
  '500': 50, '600': 43, '700': 35, '800': 28, '900': 22, '950': 14,
};

export function generatePalette(hex: string): Record<string, string> {
  const [h, s] = hexToHsl(hex);
  const palette: Record<string, string> = {};

  for (const [shade, lightness] of Object.entries(SHADE_LIGHTNESS)) {
    palette[shade] = hslToHex(h, s, lightness);
  }

  return palette;
}

export function applyPrimaryColors(hex: string): void {
  const palette = generatePalette(hex);
  const root = document.documentElement;

  for (const [shade, color] of Object.entries(palette)) {
    root.style.setProperty(`--color-primary-${shade}`, color);
  }
}
